import { Extension } from '../vscode/vs/workbench/api/common/extHostExtensionService.js';
import { isProposedApiEnabled } from '../vscode/vs/workbench/services/extensions/common/extensions.js';
import { ExtensionKind } from '../vscode/vs/workbench/api/common/extHostTypes.js';
import { Event } from 'monaco-editor/esm/vs/base/common/event.js';
import { getExtHostServices } from './extHost.js';
function create(getExtension) {
    return {
        getExtension(extensionId, includeFromDifferentExtensionHosts = false) {
            const { extHostExtensionService: extensionService } = getExtHostServices();
            const extensionInfo = extensionService.getExtensionRegistries();
            const extension = getExtension();
            if (!isProposedApiEnabled(getExtension(), 'extensionsAny')) {
                includeFromDifferentExtensionHosts = false;
            }
            const mine = extensionInfo.mine.getExtensionDescription(extensionId);
            if (mine != null) {
                return new Extension(extensionService, extension.identifier, mine, ExtensionKind.UI, false);
            }
            if (includeFromDifferentExtensionHosts) {
                const foreign = extensionInfo.all.getExtensionDescription(extensionId);
                if (foreign != null) {
                    return new Extension(extensionService, extension.identifier, foreign, ExtensionKind.UI, true);
                }
            }
            return undefined;
        },
        get all() {
            const { extHostExtensionService } = getExtHostServices();
            const extensionInfo = extHostExtensionService.getExtensionRegistries();
            const result = [];
            for (const desc of extensionInfo.mine.getAllExtensionDescriptions()) {
                result.push(new Extension(extHostExtensionService, getExtension().identifier, desc, ExtensionKind.UI, false));
            }
            return result;
        },
        get onDidChange() {
            const { extHostExtensionService } = getExtHostServices();
            const extensionInfo = extHostExtensionService.getExtensionRegistries();
            if (isProposedApiEnabled(getExtension(), 'extensionsAny')) {
                return Event.any(extensionInfo.mine.onDidChange, extensionInfo.all.onDidChange);
            }
            return extensionInfo.mine.onDidChange;
        }
    };
}
export { create as default };
